// removed by extract-text-webpack-plugin
module.exports = {"root":"root__4PyOE"};


//////////////////
// WEBPACK FOOTER
// ./src/index.css
// module id = 1591
// module chunks = 0